/* External */
import { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';

/* Components */
import VirtualizedList, { ItemDataProvider } from '../VirtualizedList';
import EpisodeSelectorRow from './EpisodeSelectorRow';

/* Utils */
import { noOp } from '../../utils/functions';
import { sizeByViewport } from '../../utils/cardsUtils';

/* Styles */
import './EpisodeSelector.scss';

const HEIGHT = sizeByViewport(1080);
const CARD_HEIGHT = sizeByViewport(
  275 /* height */
  + 32 /* margin-bottom */,
);
const FIRST_CARD_HEIGHT = sizeByViewport(
  275 /* height */
  + 32 /* margin-bottom */
  + 252 /* margin-top */,
);

function EpisodeSelector({
  episodes,
  focusRestorable,
  onEpisodeArrowPress,
  onEpisodeEnterPress,
}) {
  const itemSize = useCallback((index) => {
    if (index === 0) return FIRST_CARD_HEIGHT;

    return CARD_HEIGHT;
  }, []);

  const itemData = useMemo(() => ({
    episodes,
    focusRestorable,
    onEpisodeArrowPress,
    onEpisodeEnterPress,
  }), [
    episodes,
    focusRestorable,
    onEpisodeArrowPress,
    onEpisodeEnterPress,
  ]);

  return (
    <ItemDataProvider itemData={itemData}>
      <VirtualizedList
        className="dtv-html5-c-episode-selector"
        height={HEIGHT}
        itemSize={itemSize}
        itemCount={episodes?.size || 0}
        renderer={EpisodeSelectorRow}
        propagateEventOnReachTop
      />
    </ItemDataProvider>
  );
}

EpisodeSelector.propTypes = {
  episodes: PropTypes.instanceOf(List),
  focusRestorable: PropTypes.bool,
  onEpisodeArrowPress: PropTypes.func,
  onEpisodeEnterPress: PropTypes.func,
};

EpisodeSelector.defaultProps = {
  episodes: undefined,
  focusRestorable: false,
  onEpisodeArrowPress: noOp,
  onEpisodeEnterPress: noOp,
};

export default withFocusable()(memo(EpisodeSelector));
